import { Link } from "react-router-dom";
import about1 from "../assets/img/about-1.png";
import about2 from "../assets/img/about-2.png";
import user from "../assets/img/user.webp";

export default function About() {
    document.title = 'À propos - Suplib';

    return (
        <>
            <section>
                <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                    <div className="max-w-screen-lg sm:text-lg">
                        <h2 className="mb-4 text-4xl tracking-tight font-bold">La librairie de vos envies</h2>
                        <p className="mb-4 font-light">
                            En effet, Suplib est une librairie en ligne qui vous permet de trouver des livres de tout genre.
                        </p>
                        <p className="mb-4 font-light">
                            Que ce soit à travers des romans captivants ou des histoires de science-fiction fascinantes,
                            les livres ont le pouvoir magique de nous transporter dans des mondes imaginaires.
                            Ils nous emmènent dans des voyages extraordinaires à travers l'imagination des écrivains,
                            où les rêves prennent vie et de nouveaux univers prennent forme.
                            La force envoûtante des livres réside dans leur capacité à nous plonger
                            dans des réalités inconnues et à ancrer en nous des émotions inoubliables.
                        </p>
                    </div>
                </div>
            </section>

            <section>
                <div className="gap-16 items-center py-8 px-4 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-16 lg:px-6">
                    <div className="font-light sm:text-lg">
                        <h2 className="mb-4 text-4xl tracking-tight font-extrabold">Mais pourquoi cette librarie ?</h2>
                        <p className="mb-4">Le site est né d'un projet scolaire. </p>
                        <p>Via l'API OpenLibrary, le site récupère les livres indexés dans l'API afin de vous donner la possibilité de rechercher ou voir plus de détails sur un livre. </p>
                    </div>
                    <div className="grid grid-cols-2 gap-4 mt-8">
                        <img className="w-full rounded-lg" src={about2} alt="Librairie"/>
                        <img className="mt-4 w-full lg:mt-10 rounded-lg" src={about1} alt="Librairie"/>
                    </div>
                </div>
            </section>

            <section>
                <div className="py-8 px-4 mx-auto">
                    <div className="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
                        <h2 className="mb-4 text-4xl tracking-tight font-extrabold">Auteur du site</h2>
                    </div>
                    <div className="flex justify-center">
                        <div className="bg-card items-center rounded-lg shadow sm:flex">
                            <Link to="#">
                                <img className="w-44 rounded-lg sm:rounded-none sm:rounded-l-lg" src={user} alt="Utilisateur"/>
                            </Link>
                            <div className="p-5">
                                <h3 className="text-xl font-bold tracking-tight">
                                    <Link to="#">Samy Hammouche</Link>
                                </h3>
                                <span>Développeur Frontend</span>
                                <p className="mt-3 mb-4 font-light">Site développé en ReactJS et TailwindCSS</p>
                                <ul className="flex space-x-4 sm:mt-0">
                                    <li>
                                        <Link to="https://github.com/Hvtred/" target="_blank">
                                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" /></svg>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}